export default __webpack_public_path__ + "static/media/617.7f887d77.gif";